// 用户信息
/* eslint-disable */
export function getParams (key) {
  const params = window.location.hash.split('?')[1] || window.location.search.slice(1)
  if (!params) return null
  const reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)', 'i')
  const r = params.match(reg)

  if (r !== null) return unescape(r[2])

  return null
}

// 去掉链接上多余的参数
export function getnewurl (name) {
  var loca = window.location;
  var baseUrl = loca.origin + loca.pathname + "?";
  var query = loca.search.substr(1);
  if (query.indexOf(name) > -1) {
    var obj = {}
    var arr = query.split("&");
    for (var i = 0; i < arr.length; i++) {
      arr[i] = arr[i].split("=");
      obj[arr[i][0]] = arr[i][1];
    };
    delete obj[name];
    var url = baseUrl + JSON.stringify(obj).replace(/[\"\{\}]/g, "").replace(/\:/g, "=").replace(/\,/g, "&");
    return url
  };
}

const TokenKey = 'token'

export function getToken () {
  return localStorage.getItem(TokenKey) || ''
}

export function setToken (token) {
  return localStorage.setItem(TokenKey, token)
}

export function removeToken () {
  return localStorage.removeItem(TokenKey)
}
